import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Mail } from "lucide-react";
import "./authStyles.css";
import bgi from "../assets/Apricverseuse.jpeg";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const { forgotPassword } = useAuth();
  const [login, setLogin] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    
    try {
      const result = await forgotPassword(login);
      if (result.success) {
        setSuccess(true);
      } else {
        setError(result.message || 'Failed to send password reset link');
      }
    } catch (error) {
      console.error('Forgot password error:', error);
      setError('An unexpected error occurred');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-image">
        <img src={bgi} alt="Agriculture imagery" />
        <div className="absolute-logo">
          <img
            src="/AGRICVERSE_DARK.png"
            alt="AgricVerse Logo"
            style={{ height: 60, cursor: "pointer" }}
            onClick={() => navigate("/")}
          />
        </div>
      </div>
      <div className="auth-form-container">
        <div className="auth-form-wrapper">
          <div className="form-section active">
            <div className="form-header">
              <h1 className="form-title">Forgot Password</h1>
              <p className="form-subtitle">
                Enter your email or phone number to receive a password reset link
              </p>
            </div>

            {error && (
              <div className="error-text" style={{
                backgroundColor: '#fee2e2',
                border: '1px solid #fca5a5',
                color: '#991b1b',
                padding: '12px 16px',
                borderRadius: '8px',
                marginBottom: '16px',
                fontSize: '14px',
                fontWeight: '500'
              }}>
                {error}
              </div>
            )}

            {success ? (
              <div style={{
                backgroundColor: '#dcfce7',
                border: '1px solid #86efac',
                color: '#166534',
                padding: '16px',
                borderRadius: '8px',
                marginBottom: '16px'
              }}>
                <p style={{ margin: 0, fontWeight: '500' }}>
                  Password reset link has been sent to your email. Please check your inbox.
                </p>
                <button
                  onClick={() => navigate('/login')}
                  style={{
                    marginTop: '12px',
                    background: '#0e4410',
                    color: 'white',
                    border: 'none',
                    padding: '8px 16px',
                    borderRadius: '6px',
                    cursor: 'pointer'
                  }}
                >
                  Back to Login
                </button>
              </div>
            ) : (
              <form className="auth-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="forgot-login">Email or Phone Number</label>
                  <div className="input-group">
                    <Mail size={18} />
                    <input
                      type="text"
                      id="forgot-login"
                      name="login"
                      value={login}
                      onChange={(e) => setLogin(e.target.value)}
                      placeholder="Enter your email or phone number"
                      required
                      disabled={isLoading}
                    />
                  </div>
                </div>

                <button 
                  type="submit" 
                  className="primary-button"
                  disabled={isLoading}
                >
                  {isLoading ? 'Sending...' : 'Send Reset Link'}
                </button>
              </form>
            )}

            <div className="form-footer">
              <p>
                Remember your password?{" "}
                <button
                  onClick={() => navigate("/login")}
                  className="link-button"
                  disabled={isLoading}
                >
                  Login
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

